var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclefirmware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 22.989C18.8794 22.989 23.5347 18.3337 23.5347 12.7043C23.5347 7.06464 18.8794 2.41962 13.2397 2.41962C7.61035 2.41962 2.96533 7.06464 2.96533 12.7043C2.96533 18.3337 7.62061 22.989 13.25 22.989ZM13.25 21.6559C8.28711 21.6559 4.29834 17.6569 4.29834 12.7043C4.29834 7.74139 8.28711 3.74237 13.2397 3.74237C18.2026 3.74237 22.2017 7.74139 22.2119 12.7043C22.2119 17.6569 18.2129 21.6559 13.25 21.6559ZM13.25 7.54657C12.9014 7.54657 12.6553 7.79266 12.6553 8.15155V14.0988L12.7065 15.9855L11.5786 14.7243L10.1021 13.2375C9.98926 13.1247 9.85596 13.0632 9.68164 13.0632C9.35352 13.0632 9.10742 13.3093 9.10742 13.6271C9.10742 13.8015 9.15869 13.9348 9.26123 14.0475L12.7988 17.5646C12.9526 17.7184 13.0859 17.7902 13.25 17.7902C13.4243 17.7902 13.5679 17.7184 13.7114 17.5646L17.249 14.0475C17.3516 13.9348 17.4131 13.8015 17.4131 13.6271C17.4131 13.3093 17.1567 13.0632 16.8286 13.0632C16.6543 13.0632 16.521 13.1247 16.4082 13.2375L14.9316 14.7243L13.7935 15.9958L13.855 14.0988V8.15155C13.855 7.79266 13.6089 7.54657 13.25 7.54657Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclefirmware);
export default __webpack_public_path__ + "static/media/Circle firmware.b1229cc6cfbafb60db453dec584a6454.svg";
export { ForwardRef as ReactComponent };